import React, {useState} from 'react';
import {asREM, cn} from '../../Utilities';
import * as css from './RsnLogoSpinner.css';

export const RsnLogoSpinner = React.memo(function RsnLogoSpinner({
    size = '100%',
    spinning = true,
}: {
    size?: string | number;
    spinning?: boolean;
}) {
    if (typeof size === 'number') {
        size = asREM(size);
    }

    const [finished, setFinished] = useState(!spinning);
    const shouldAnimate = spinning || !finished;

    return (
        <svg
            width={size}
            height={size}
            viewBox='0 0 36 36'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            onAnimationStart={() => {
                setFinished(false);
            }}
            onAnimationIteration={() => {
                if (!spinning) {
                    setFinished(true);
                }
            }}
        >
            <rect
                className={cn(css.black, shouldAnimate && css.spinBlack)}
                x='0%'
                y='50%'
                width='18'
                height='18'
                rx='0'
            />
            <rect
                className={cn(css.blue, shouldAnimate && css.spinBlue)}
                x='50%'
                y='0%'
                width='18'
                height='18'
                rx='0'
            />
        </svg>
    );
});
